import React from "react"

import { Box } from "components"

const Wrapper = ({ children, maxWidth, ...rest }) => (
  <Box data-component-id="wrapper" as="section" {...rest}>
    <Box
      data-component-id="wrapper.inner"
      width="100%"
      maxWidth={maxWidth}
      mx="auto"
    >
      {children}
    </Box>
  </Box>
)

Wrapper.defaultProps = {
  maxWidth: 1152,
  my: ["layout.5", "layout.6", "layout.7"],
  px: ["layout.3", "layout.6"],
  bg: "background",
}

export default Wrapper
